import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";
import authSlice from "./slices/authSlice";

const persistConfig = {
  key: "layout",
  storage,
};

export const store = configureStore({
  reducer: {
    auth: authSlice,
  },
});

export const persistor = persistStore(store);

// INFO: Exporting auth actions and thunks
export { signout } from "./slices/authSlice";

export * from "./thunks/authThunks";
